/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InvoiceDocumentSearch } from '../../models/invoice-document-search';
import { InvoiceDocumentSearchResult } from '../../models/invoice-document-search-result';

export interface SearchInvoiceDocuments$Params {
  page: number;
  size: number;
  sort?: string;
  order?: string;
      body: InvoiceDocumentSearch
}

export function searchInvoiceDocuments(http: HttpClient, rootUrl: string, params: SearchInvoiceDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceDocumentSearchResult>> {
  const rb = new RequestBuilder(rootUrl, searchInvoiceDocuments.PATH, 'post');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
    rb.query('order', params.order, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InvoiceDocumentSearchResult>;
    })
  );
}

searchInvoiceDocuments.PATH = '/invoice-document/search';
